import axios from 'axios';
import { secureStorage } from '../Utils/encryption';

const axiosInstance = axios.create({
    // baseURL: 'http://13.232.134.145/roam4less_backend/public',
    baseURL: 'https://roam4less.app/backend/',
    // baseURL: 'http://localhost:8000/',
    timeout: 100000,
    // Add headers for better browser compatibility
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    }
});

// Helper function to get token from either storage method
const getToken = () => {
    try {
        // First try secureStorage (for admin)
        const secureToken = secureStorage.getItem('token');
        if (secureToken) {
            return secureToken;
        }

        // Fallback to regular localStorage (for regular users)
        const regularToken = localStorage.getItem('token');
        if (regularToken) {
            try {
                return JSON.parse(regularToken);
            } catch (e) {
                return regularToken;
            }
        }

        return null;
    } catch (error) {
        console.error('Error getting token:', error);
        return null;
    }
};

// Helper function to get frontend version from either storage method
const getFrontendVersion = () => {
    try {
        // First try secureStorage
        const secureVersion = secureStorage.getItem('frontend_version');
        if (secureVersion) {
            return secureVersion;
        }

        // Fallback to regular localStorage
        return localStorage.getItem('frontend_version');
    } catch (error) {
        console.error('Error getting frontend version:', error);
        return localStorage.getItem('frontend_version');
    }
};

// Helper function to set frontend version in both storage methods
const setFrontendVersion = (version) => {
    try {
        secureStorage.setItem('frontend_version', version);
        localStorage.setItem('frontend_version', version);
    } catch (error) {
        console.error('Error setting frontend version:', error);
        localStorage.setItem('frontend_version', version);
    }
};

// Helper function to clear storage
const clearStorage = () => {
    try {
        secureStorage.clear();
        localStorage.clear();
    } catch (error) {
        console.error('Error clearing storage:', error);
        localStorage.clear();
    }
};

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
    function (config) {
        const token = getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

const localVersion = getFrontendVersion();

axiosInstance.interceptors.response.use(
    function (response) {
        // Fix browser compatibility issue with header access
        const frontendVersion = response.headers['frontend_version'] || response.headers.get?.('frontend_version');

        if (frontendVersion) {
            setFrontendVersion(frontendVersion);
        }

        if (localVersion === frontendVersion) {
            return response;
        } else if (localVersion == null || localVersion == undefined || localVersion == 'undefined' || localVersion == 'null') {
            return response;
        } else {
            clearStorage();
            window.location.href = '/';
        }
    },
    function (error) {
        // Improved error handling for browser compatibility
        console.error('API Error:', error);

        if (error?.response?.status === 401) {
            // Handle unauthorized access - clear both storage methods
            try {
                secureStorage.removeItem('token');
                localStorage.removeItem('token');
            } catch (e) {
                localStorage.removeItem('token');
            }
            // toast.error(error?.response?.data?.message)
        } else if (error?.code === 'ERR_NETWORK') {
            // Handle network errors (CORS, connection issues)
            console.error('Network error - possible CORS issue:', error);
        } else if (error?.response?.status === 0) {
            // Handle CORS errors
            console.error('CORS error detected:', error);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;